import React from 'react';
import { ChipVariant } from '../../types';

interface ChipProps {
  children: React.ReactNode;
  variant?: ChipVariant;
}

const variantStyles: Record<ChipVariant, React.CSSProperties> = {
  success: { background: 'var(--success-dim)', color: 'var(--success)', border: '1px solid rgba(16,185,129,0.3)' },
  warn:    { background: 'var(--warning-dim)', color: 'var(--warning)', border: '1px solid rgba(245,158,11,0.3)' },
  error:   { background: 'var(--error-dim)',   color: 'var(--error)',   border: '1px solid rgba(239,68,68,0.3)' },
  info:    { background: 'var(--accent-dim)',  color: 'var(--accent)',  border: '1px solid rgba(0,229,255,0.3)' },
  muted:   { background: 'var(--surface2)',    color: 'var(--text-muted)', border: '1px solid var(--border)' },
};

const Chip: React.FC<ChipProps> = ({ children, variant = 'muted' }) => (
  <span
    style={{
      display: 'inline-block',
      padding: '4px 12px',
      borderRadius: 'var(--radius-full)',
      fontSize: '0.72rem',
      fontWeight: 700,
      letterSpacing: '0.04em',
      ...variantStyles[variant],
    }}
  >
    {children}
  </span>
);

export default Chip;
